// src/constants/index.js

export const USER_TOKEN = 'userToken';
export const STATUS_CODE_SUCCESS = 200;
export const STATUS_CODE_NOT_FOUND = 404;
export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'zh', 'fr'];

// 可以添加更多常量...